import React from "react";
import { Button, Typography } from "antd";
import { Link } from "react-router-dom";
import { detectionLogo1 } from "../images";

const { Title } = Typography;

function DetectionLogo() {
  return (
    <div>
      <img
        style={{ marginTop: "-18px" }}
        src={detectionLogo1}
        alt="Detection Logo"
      />
    </div>
  );
}

export default DetectionLogo;
